<p-card  styleClass="p-card-body-pb-0 serviceCard">
    <ng-template pTemplate="header">
        <div class="flex">
            <h3 class="m-0 mr-4"> Datos de la cita <span *ngIf="showLilnkCase"> - <a  style="text-decoration: none;" [routerLink]="['/cases', case.id]" target="_blank"> {{case.caseNumber}}</a> </span></h3> 
       </div>
    </ng-template>
    <form c *ngIf="caseServiceFormGroup" [formGroup]="caseServiceFormGroup">
        <div class="grid">
            <div class="col-2 input-field">
                <label for="date">Fecha inicio</label>
                <!--<p-calendar [firstDayOfWeek]="1" formControlName="date" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
                    [yearNavigator]="true" dateFormat="dd/mm/yy" [showTime]="true" d-form-field-error appendTo="body" [disabled]="true"
                    >
                    </p-calendar>-->
                    <p-calendar [firstDayOfWeek]="1" formControlName="date" d-form-field-error appendTo="body"  id="date" [dateFormat]="'dd/mm/yy'" [showTime]="true" [showIcon]="true"></p-calendar>
            </div>
            <div class="col-2 input-field">
                <label for="estimatedDateEnd">Fecha fin</label>
                <!--<p-calendar [firstDayOfWeek]="1" formControlName="estimatedDateEnd" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
                    [yearNavigator]="true" dateFormat="dd/mm/yy" [showTime]="true" d-form-field-error appendTo="body"></p-calendar>-->
                    <p-calendar formControlName="estimatedDateEnd" d-form-field-error appendTo="body"  id="estimatedDateEnd" dateFormat="dd/mm/yy" [showTime]="true" [showIcon]="true"></p-calendar>
            </div>
            <div class="col-4 input-field">
                <label for="workerId">Operario <a class="p-button-text" icon="pi pi-info-circle" href="workers/{{caseService.workerId}}" target="_blank" onlyIcon="true" p-tooltip="Ver información operario" ><i class="pi pi-info-circle"></i></a></label>
                <p-dropdown [options]="workers" formControlName="workerId" optionLabel="name" optionValue="id"
                        [filter]="true" filterBy="name" appendTo="body" placeholder="Selecciona un operador"  id="workerId"
                        d-form-field-error></p-dropdown>
                <div class="flex gap-2">
                    <a *ngIf="caseService.worker?.phone1" (click)="showPhoneOverlayPanel($event, caseService.worker?.phone1, caseService.worker?.name)" class="p-button-link"><i
                        class="pi pi-phone"></i> {{caseService.worker?.phone1}}</a>
                    <a *ngIf="caseService.worker?.phone2" (click)="showPhoneOverlayPanel($event, caseService.worker?.phone2, caseService.worker?.name)" class="p-button-link"><i
                        class="pi pi-phone"></i> {{caseService.worker?.phone2}} </a>
                     <a *ngIf="caseService.worker?.email!=null" (click)="mail(caseService.worker?.email, case.id, caseService.id, false)"><i class="pi pi-envelope mr-1"></i>{{caseService.worker?.email}}</a>

                </div>
            </div>
            <div class="col-2 input-field">
                <label for="capabilityId">Especialidad</label>
                <p-dropdown [options]="capabilities" formControlName="capabilityId" [filter]="true"
                    filterBy="name" placeholder="Seleccione una especialidad" optionLabel="name" optionValue="id"  id="capabilityId"
                    d-form-field-error appendTo="body"></p-dropdown>
            </div>
            <div class="col-2 input-field">
                <label for="reclamationType">Reclamación</label>
                <p-dropdown [options]="reclamationTypes" formControlName="reclamationType" optionLabel="label" optionValue="value"
                    [filter]="true" filterBy="label" appendTo="body" placeholder="No" id="reclamationType"
                    d-form-field-error></p-dropdown>
            </div>   
            <div class="col-3 input-field">
                <label for="targetId">Destinatario</label>
                <p-dropdown [options]="targets" [(ngModel)]="targetId" [ngModelOptions]="{standalone:true}" optionLabel="name" optionValue="id"
                appendTo="body" [filter]="true" filterBy="name" placeholder="Selecciona un destinatario"  id="targetId" [disabled]="true"
                d-form-field-error (onChange)="targetSelected()"></p-dropdown>
            </div>
            <div class="col-9 input-field">
                <label for="targetAddress">Dirección</label>
                <input pInputText [(ngModel)]="targetAddress" [ngModelOptions]="{standalone:true}" placeholder="" d-form-field-error [disabled]="true"  id="targetAddress"/>
            </div>
            <div class="col-12 input-field">
                <label for="notes">Instrucciones de trabajos a realizar</label>
                <textarea #autoGrowTextarea pInputTextarea
                        formControlName="notes" style="max-height: 320px; overflow-y: hidden; resize: none;"
                        (input)="this.stringUtils.ResizeTextarea($event, 320)" 
                        (focus)="stringUtils.ResizeTextarea($event, 320)"  
                        rows="1" d-form-field-error  id="notes"></textarea>
                <small class="p-error" *ngIf="formValidationService.getValidationMessage(caseServiceFormGroup, 'notes', { }) as notesError">{{ notesError }}</small>
            </div>
            <div class="col-12 input-field">
                <label for="economicNotes">Información económica/privada</label>
                <textarea #autoGrowTextarea pInputTextarea formControlName="economicNotes" style="max-height: 320px; overflow-y: hidden; resize: none;" (input)="stringUtils.ResizeTextarea($event, 320)" (focus)="stringUtils.ResizeTextarea($event, 320)"  rows="1" d-form-field-error  id="economicNotes"></textarea>
            </div>
            <div class="col-12 input-field" *ngIf="budgetsFromWorker.length > 0">
                <label for="workerBudgetTransactionId">Presupuesto de operario asociado</label>
                <p-dropdown [options]="budgetsFromWorker" formControlName="workerBudgetTransactionId"  optionLabel="code" optionValue="id"
                appendTo="body" [filter]="true" filterBy="code" placeholder="Selecciona un presupuesto"  id="workerBudgetTransactionId"
                d-form-field-error></p-dropdown>
            </div>
            <div class="col-1 input-field">
                <label for="notModify">No modificar</label>
                <p-inputSwitch formControlName="notModify" d-form-field-error  id="notModify"></p-inputSwitch>
            </div>
            <!--<div class="col-1 input-field">
                <label for="isValidated">Validado</label>
                <p-inputSwitch formControlName="isValidated" d-form-field-error  id="isValidated"></p-inputSwitch>
            </div>-->
            <div class="col-1 input-field">
                <label for="isUrgent">Urgente</label>
                <p-inputSwitch formControlName="isUrgent" d-form-field-error  id="isUrgent"></p-inputSwitch>
            </div>  
            <div class="col-1 input-field">
                <label for="isConfirmed">Confirmada</label>
                <p-inputSwitch formControlName="isConfirmed" d-form-field-error  id="isConfirmed"></p-inputSwitch>
            </div>            
            <div class="col-1 input-field">
                <label for="isGuard">Horario de guardia</label> 
                <p-inputSwitch formControlName="isGuard" d-form-field-error  id="isGuard"></p-inputSwitch>
            </div>
            <div class="col-2 input-field">
                <label for="isBudgetRequired">Presupuesto obligatorio</label>
                <p-inputSwitch formControlName="isBudgetRequired" d-form-field-error id="isBudgetRequired"></p-inputSwitch>
            </div>
            <div class="col-2 input-field" *ngIf="showSinCitarCheck">
                <label for="isNotScheduled">Sin citar</label>
                <p-inputSwitch formControlName="isNotScheduled" d-form-field-error id="isNotScheduled"></p-inputSwitch>
            </div>
            <div class="col-4 input-field" *ngIf="allowMaterials">
                <label for="materials">Materiales a retirar</label>
                <p-multiSelect [options]="materials" [(ngModel)]="selectedMaterials" [filter]="true"
                    filterBy="name" placeholder="Seleccione materiales" optionLabel="name" optionValue="id"
                    [ngModelOptions]="{standalone: true}" appendTo="body"
                    selectedItemsLabel="{0} materiales"></p-multiSelect>
            </div>
             <div class="col input-field">
                <label for="allowRegisterDataOffTheClock" >Permitir registro de información fuera de hora</label>
                <p-inputSwitch formControlName="allowRegisterDataOffTheClock" d-form-field-error></p-inputSwitch>

            </div>
        </div>
        <div class="mt-2 flex gap-2 justify-content-end">            
            <p-button label="Eliminar" *ngIf="allowDelete && caseService.dateStart==null" icon="pi pi-trash" styleClass="p-button-danger"
                (click)="delete()"></p-button>
            <p-button label="Cancelar" *ngIf="allowWrite && caseService.dateStart==null && !caseService.cancelCaseServiceCauseId && !caseService.cancelCaseServiceReasonId && !caseService.cancelCaseServiceReasonNotes" icon="pi pi-thumbs-down" styleClass="p-button-danger"
                (click)="cancelCaseModal()"></p-button>
            <div class="flex-grow-1"></div>
            <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
            <p-button label="Guardar" *ngIf="allowWrite && !caseService.cancelCaseServiceReasonId && !caseService.cancelCaseServiceReasonNotes" icon="pi pi-check" styleClass="p-ml-2"
                (click)="save()"></p-button>
        </div>
        <div class="mt-4" *ngIf="(caseService.cancelCaseServiceCauseId||caseService.cancelCaseServiceReasonId||caseService.cancelCaseServiceReasonNotes) && !showCancelCaseModal">
            <p-messages severity="error">
                <ng-template pTemplate>
                    <b>{{caseService.cancelCaseServiceCause?.name}} - {{cancelCaseServiceReason.name}}</b> &nbsp;&nbsp;&nbsp;{{caseService.cancelCaseServiceReasonNotes}}
                </ng-template>
            </p-messages>
        </div>
    </form>
</p-card>
<p-card header="Datos de la intervención" styleClass="mt-4">
    <form *ngIf="caseServiceFormGroup" [formGroup]="caseServiceFormGroup">
        <div class="grid">
            <div class="col-2 input-field">
                <label for="dateStart">Fecha de inicio</label>
                <p-calendar [firstDayOfWeek]="1" formControlName="dateStart" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"  id="dateStart"
                    [yearNavigator]="true" dateFormat="dd/mm/yy" [showTime]="true" d-form-field-error appendTo="body" 
                    [disabled]="!caseServiceFormGroup.get('isConfirmed')?.value"></p-calendar>   
            </div>
            <div class="col-2 input-field">
                <label for="dateEnd">Fecha de fin</label>
                <p-calendar [firstDayOfWeek]="1" formControlName="dateEnd" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"  id="dateEnd"
                    [yearNavigator]="true" dateFormat="dd/mm/yy" [showTime]="true" d-form-field-error appendTo="body" 
                    [disabled]="!caseServiceFormGroup.get('isConfirmed')?.value"></p-calendar>
            </div>
            <div class="col-5 input-field" style="display:flex; padding-top: 25px; align-items: center;" *ngIf="!caseServiceFormGroup.get('isConfirmed')?.value">
                <label class="text-danger">No se puede poner fecha si el servicio no está confirmado</label>
            </div>
            <div class="col-12 input-field">
                <label for="pendingTasksDescription">Trabajos pendientes  </label>
                <textarea #autoGrowTextarea formControlName="pendingTasksDescription" style="max-height: 320px; overflow-y: hidden; resize: none;" (input)="this.stringUtils.ResizeTextarea($event, 320)" pInputTextarea rows="1"  id="pendingTasksDescription"
                    d-form-field-error></textarea>
                <small class="p-error" *ngIf="formValidationService.getValidationMessage(caseServiceFormGroup, 'pendingTasksDescription', { }) as pendingTasksDescriptionError">{{ pendingTasksDescriptionError }}</small>

            </div>
            <div class="col-12 input-field">
                <label for="realizedTasksDescription">Trabajos realizados</label>
                <textarea #autoGrowTextarea formControlName="realizedTasksDescription" style="max-height: 320px; overflow-y: hidden; resize: none;" (input)="this.stringUtils.ResizeTextarea($event, 320)" pInputTextarea rows="1"  id="realizedTasksDescription"
                    d-form-field-error></textarea>
                <small class="p-error" *ngIf="formValidationService.getValidationMessage(caseServiceFormGroup, 'realizedTasksDescription', { }) as realizedTasksDescriptionError">{{ realizedTasksDescriptionError }}</small>

            </div>
        </div>
    </form>
    <div *ngIf="images.length>0" class="p-card-title mt-2">
        Archivos
    </div>
    <div class="hovered-image" *ngIf="hoveredImage!=null">
        <img [src]="imagesUrl + hoveredImage.fileId + '/show'" style="max-width: 600px; max-height: 600px;" />
    </div>
    <div class="grid mt-2">
        <!--<p-overlayPanel #op [appendTo]="'body'" styleClass="image-overlay-panel">
            <img *ngIf="opImage" [src]="imagesUrl + opImage?.fileId + '/show'" style="max-height: 600px; max-width: 500px; border-radius: 10px;" />
        </p-overlayPanel>-->
        <div *ngFor="let image of images" class="col-1 imagen-item">        
            <img [d-img-lazy]="imagesUrl + image.fileId + '/thumbnail'" width="100" height="100"
                [style.cursor]="'pointer'"
                (click)="downloadFile(image.fileId)"
                (mouseenter)="hoveredImage = image"
                (mouseleave)="hoveredImage = null"
                >
        </div>
    </div>
    <div *ngIf="caseService.dateEnd" class="p-card-title mt-2">
        Firmas del servicio
    </div>
    <div *ngIf="caseService.dateEnd"  class="p-card-title mt-2">
        <div *ngIf="caseService.clientSignatureDenied" class="flex align-items-center gap-2">
            <i class="pi pi-exclamation-triangle" style="font-size: 1.5em; color: red;"></i>
            <span>{{caseService.clientSignatureDeniedReason}}</span>
        </div>
        <div *ngIf="caseService.signatureId" class="flex align-items-center gap-2">
            <img [d-img-lazy]="imagesUrl + caseService.signatureId + '/show'" width="100" height="100"                
                [style.cursor]="'pointer'">
            {{caseService.case?.client?.name}} -  {{caseService.case?.client?.vatNumber}}
        </div>
        <div *ngIf="!caseService.signatureId" class="flex align-items-center gap-2">
            <div *ngFor="let other of otherImages">
                <div class="col-1 imagen-item">
                    <img [d-img-lazy]="imagesUrl + other.fileId + '/show'" width="100" height="100"                
                        [style.cursor]="'pointer'">
                </div>        
                <div>{{other.name}} {{other.documentId}}</div>
            </div>
        </div>
    </div>
</p-card>


<p-dialog header="Cancelar cita" [(visible)]="showCancelCaseModal" [modal]="true" [closable]="true" [style]="{width: '500px'}">
    <div class="col-12 input-field">
        <label for="cancelCaseServiceCauseId">Causa</label>
        <p-dropdown (onChange)="cancelCaseServiceReasons($event)"
                [(ngModel)]="caseService.cancelCaseServiceCauseId"
                id="cancelCaseServiceCauseId" [options]="cancelServiceCauses" optionLabel="name" optionValue="id"
                appendTo="body" [filter]="true" filterBy="name"
                d-form-field-error></p-dropdown>
    </div>
    <div class="col-12 input-field">
        <label for="cancelCaseServiceReasonId">Motivo</label>
        <p-dropdown [(ngModel)]="caseService.cancelCaseServiceReasonId" id="cancelCaseServiceReasonId" [options]="cancelServiceReasons" optionLabel="name" optionValue="id"
                appendTo="body" [filter]="true" filterBy="name"
                d-form-field-error></p-dropdown>
    </div>
    <div class="col-12 input-field" *ngIf="caseService.cancelCaseServiceReasonId=='-1'">
        <label for="cancelCaseServiceReasonNotes">Motivo de cancelación</label>
        <textarea [(ngModel)]="caseService.cancelCaseServiceReasonNotes" id="cancelCaseServiceReasonNotes" pInputTextarea rows="5" d-form-field-error></textarea>
    </div>

    <div class="col-12 input-field flex gap-2 align-items-center">
        <p-checkbox [binary]="true" (onChange)="loadInfoIncident($event)" ></p-checkbox >
        <label for="createAlert">Crear incidencia</label>
    </div>
    <form [formGroup]="incidentFormGroup" *ngIf="showIncidentInfo">
        <div class="col-12 input-field">
            <label for="source">Origen</label>
            <p-dropdown id="source" [options]="sources" optionLabel="name" optionValue="id" appendTo="body"
                formControlName="source" showClear placeholder="Seleccione una opción" (onChange)="onSourceChange($event)"
                filterBy="name"></p-dropdown>
        </div>
        
        <div class="col-12 input-field">
            <label for="thirdPartyId">Selecciones</label>
            <p-dropdown id="thirdPartyId" [options]="thirdParties" optionLabel="name" optionValue="id" appendTo="body"
                formControlName="thirdPartyId" showClear [filter]="true"
                filterBy="name"></p-dropdown>
        </div>

        <div class="col-12 input-field">
            <label for="incidentTypeId">Tipo de incidencia</label>
            <p-dropdown id="incidentTypeId" [options]="incidentTypes" optionLabel="name" optionValue="id" appendTo="body"
                formControlName="incidentTypeId" showClear [filter]="true"
                filterBy="name"></p-dropdown>
        </div>
        <div class="col-12 input-field">
            <label for="notes">Descripción</label>
            <textarea pInputTextarea formControlName="description" rows="4"  d-form-field-error ></textarea>
        </div>
    </form>
    <ng-template pTemplate="footer">        
        <button pButton label="Cancelar" icon="pi pi-times" class="p-button-secondary" (click)="cancelCancelCaseModal()"></button>        
        <button pButton label="Guardar y Crear cita nueva" icon="pi pi-check" (click)="saveCancelCaseModal(true)"></button>
        <button pButton label="Guardar" icon="pi pi-check" (click)="saveCancelCaseModal(false)"></button>
    </ng-template>
</p-dialog>

<p-overlayPanel #phoneOverlayPanel>
    <div class=" flex flex-column gap-2">
        <a (click)="call(phoneOverlayPanelData.phoneNumber, phoneOverlayPanelData.callerId, case.id)">Llamar</a>
        <a (click)="sms(phoneOverlayPanelData.phoneNumber, case.id, phoneOverlayPanelData.caseServiceId)">Enviar sms</a>
        <a (click)="whatsapp(phoneOverlayPanelData.phoneNumber, case.id, phoneOverlayPanelData.callerId)">Enviar whatsapp</a>
    </div>
</p-overlayPanel>